<template>
  <div class="information">
    <div class="cooperative">
      <div class="cooperative_title color6">
        <div class="cooperative_name">负责人信息</div>
      </div>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="8">
          <div class="item_text">
            <div class="textName color6">负责人：</div>
            <div class="item_data color3">{{ Detail.contact|formatContactName }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <span class="color6">年龄：</span>
            <span class="color3">
              {{ Detail.principalAge ? Detail.principalAge + "岁" : "/" }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <div class="textName color6">籍贯：</div>
            <div class="item_data color3">
              {{ Detail.principalHometownName? Detail.principalHometownName: "/"}}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="8">
          <div class="item_text">
            <span class="textName color6">性别：</span>
            <span class="item_data color3">
              {{Detail.principalSex == null? "/" : Detail.principalSex == 0? "男": "女"}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <span class="textName color6">民族：</span>
            <span class="item_data color3">
              {{Detail.principalNationName ? Detail.principalNationName : "/"}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <span class="textName color6">身份证号：</span>
            <span class="item_data color3">
              {{Detail.idNumber ? Detail.idNumber : "/"}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="8">
          <div class="item_text">
            <span class="textName color6">职位：</span>
            <span class="item_data color3">
              {{Detail.principalPosition ? Detail.principalPosition : "/"}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <span class="textName color6">联系电话：</span>
            <span class="item_data color3" v-if="showpNumber">{{ Detail.phoneNumber }}</span>
            <span class="item_data color3" v-else>{{ ShowPhone(Detail.phoneNumber) }}</span>
            <span style="color:#0286DF;cursor: pointer;margin-left:10px" v-if="!showpNumber" @click="ShowPhoneNumber" >查看</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="itemRow">
        <template v-if="Detail.principalFieldList && Detail.principalFieldList.length">
          <el-col :span="24" class="detail-item" v-for="(field, index) in Detail.principalFieldList" :key="index">
            <span class="item-name">{{ field.name }}：</span>
            <span class="item_data color3" style="line-height:22px">{{ field.content }}</span>
          </el-col>
        </template>
      </el-row>
    </div>
    <div class="cooperative">
      <div class="cooperative_title color6">
        <div class="cooperative_name">工队信息</div>
      </div>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="8">
          <div class="item_text single_hide">
            <span class="textName color6 single_hide" style="min-width: 70px">工程专业：</span>
            <div @mouseenter="handleShowTooltip($event)">
              <el-tooltip popper-class="popperCustoms" :visible-arrow="false"  :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                <div class="single_hide" style="color: #333;max-width:295px">{{Detail.category ? Detail.category.replace(/\|/g, "/") : "/"}}</div>
                <div slot="content" class="single_hide" style="color: #666;max-width:295px">{{Detail.category ? Detail.category.replace(/\|/g, "/") : "/"}}</div>
              </el-tooltip>
            </div>
          </div>
        </el-col>
        <el-col :span="8" v-if="Detail.teamNumber&&!Number(Detail.teamSize)">
          <div class="item_text">
            <span class="color6">团队人数：</span>
            <span class="color3"> {{ Detail.teamNumber}}</span>
          </div>
        </el-col>
        <el-col :span="8" v-if="!Detail.teamNumber&&Number(Detail.teamSize)">
          <div class="item_text">
            <span class="color6">团队人数：</span>
            <span class="color3"> {{ Detail.teamSize+'人'}}</span>
          </div>
        </el-col>
        <el-col :span="8" v-if="Detail.teamNumber&&Number(Detail.teamSize)">
          <div class="item_text">
            <span class="color6">团队人数：</span>
            <span class="color3"> {{ Detail.teamSize+'人'}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text single_hide">
            <span class="textName color6 single_hide" style="min-width: 70px">工作区域：</span>
            <div @mouseenter="handleShowTooltip($event)">
              <el-tooltip popper-class="popperCustoms" :visible-arrow="false" :disabled="showTooltip"  placement="bottom" class="single_hide" effect="light">
                <div class="single_hide" style="color: #333;max-width:295px">{{Detail.serviceAreaName? Detail.serviceAreaName.replace(/\|/g, ","): "/"}}</div>
                <div slot="content" class="single_hide" style="color: #666;max-width:295px">{{Detail.serviceAreaName? Detail.serviceAreaName.replace(/\|/g, ","): "/"}}</div>
              </el-tooltip>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="24">
          <div class="item_text">
            <span class="textName color6" style="min-width: 70px;line-height:22px">工队介绍：</span>
            <span class="item_data color3" style="line-height:22px">{{ Detail.basicSituation ? Detail.basicSituation : "/" }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="itemRow">
        <template v-if="Detail.teamInfoFieldList && Detail.teamInfoFieldList.length">
          <el-col :span="24" class="detail-item" v-for="(field, index) in Detail.teamInfoFieldList" :key="index">
            <span class="item-name">{{ field.name }}：</span>
            <span class="item_data color3" style="line-height:22px">{{ field.content }}</span>
          </el-col>
        </template>
      </el-row>
    </div>
    <div class="cooperative" v-if="$route.query.companyNo && Detail.teamType === 0">
      <div class="cooperative_title color6">
        <div class="cooperative_name">隶属单位信息</div>
      </div>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="8">
          <div class="item_text">
            <div class="textName color6">公司名称：</div>
            <div class="item_data color3">{{ Detail.legalComName }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <span class="color6">统一社会信用代码：</span>
            <span class="color3"> {{ Detail.creditCode||'/' }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <div class="textName color6">注册资本：</div>
            <div class="item_data color3">
              {{ Detail.registeredCapital ? Detail.registeredCapital : "/" }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="12">
          <div class="item_text">
            <span class="textName color6">经营地址：</span>
            <span class="item_data color3">
              {{ Detail.businessAddressName }}</span
            >
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" class="itemRow">
        <el-col :span="24">
          <div class="item_img" :style="{display:Detail.filePath.length?'':'flex'}">
            <div class="textName color6">与公司的合作协议与委托书：</div>
            <div class="item_data color3">
              <template v-for="(item, index) in Detail.filePath">
                <el-image fit="cover" :key="index" v-if="item" style=" width: 80px; height: 80px; margin-right: 10px;margin-top: 10px; vertical-align: top;" :src="item" :preview-src-list="[item]"></el-image>
              </template>
            </div>
            <div v-if="!Detail.filePath.length">/</div>
          </div>
        </el-col>
      </el-row> -->
      <el-row :gutter="20" class="itemRow">
        <template v-if="Detail.addField && Detail.addField.length">
          <el-col :span="24" class="detail-item" v-for="(field, index) in Detail.addField.map(field => {return {name: Object.keys(field)[0], content: field[Object.keys(field)[0]]}})" :key="index">
            <span class="item-name">{{ field.name }}：</span>
            <span class="item_data color3" style="line-height:22px">{{ field.content }}</span>
          </el-col>
        </template>
        <el-col :span="24" class="detail-item" v-if="Detail.certificates && Detail.certificates.length">
          <span class="item-name">附件：</span>
          <span style="display: flex; flex-wrap: wrap">
            <div v-for="(file, index) in Detail.certificates" :key="index" class="file-item">
              <div class="file-item-container">
                <img :src="fileIcon[file.fileName.split('.').pop().toLowerCase()]" alt="" class="file-icon"/>
                <div class="file-info">
                  <div class="file-name">
                    <div class="fore">
                      {{ file.fileName.slice(0, file.fileName.lastIndexOf(".")) }}
                    </div>
                    <div class="back">.{{ file.fileName.split(".").pop() }}</div>
                  </div>
                  <div class="file-other">
                    <span class="file-size">{{formatFileSize(file.fileSize)}}</span>
                    <span class="file-download" @click="$previewFile(file.picture)">预览</span>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </el-col>
      </el-row>
    </div>
    <div class="cooperative" v-if="Detail.teamType === 1">
      <div class="cooperative_title color6">
        <div class="cooperative_name">隶属单位信息</div>
      </div>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="8">
          <div class="item_img">
            <div class="textName color6">
              隶属单位：
              <span class="color3" v-if=" Detail.affiliatedUnitPic == null || Detail.affiliatedUnitPic == '' " >/</span >
              <span class="color3" v-else :style="{ cursor: hasAffCom ? 'pointer' : 'auto' }" @click="jumpComSite(Detail)" >
                {{ hasAffCom ? Detail.affiliatedUnitPic : "/" }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <span class="textName color6">法人：</span>
            <span class="item_data color3">
              {{ hasAffCom && Detail.legalPerson ? Detail.legalPerson : "/" }}
            </span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <span class="textName color6">代征证号：</span>
            <span class="item_data color3">
              {{ hasAffCom && Detail.certificateNumber ? Detail.certificateNumber: "/"}}
            </span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="itemRow">
        <el-col :span="8">
          <div class="item_text">
            <span class="textName color6">经营地址：</span>
            <span class="item_data color3">
              {{ hasAffCom && Detail.affBusinessAddressName ? Detail.affBusinessAddressName : "/"}}
            </span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item_text">
            <div class="textName color6">注册资本：</div>
            <div class="item_data color3">
              {{ hasAffCom && Detail.affRegisteredCapital ? Detail.affRegisteredCapital : "/" }}
            </div>
          </div>
        </el-col>
        <template v-if="Detail.addField && Detail.addField.length">
          <el-col :span="24" class="detail-item" v-for="(field, index) in Detail.addField.map(field => { return { name: Object.keys(field)[0], content: field[Object.keys(field)[0]] }})" :key="index">
            <span class="item-name">{{ field.name }}：</span>
            <span class="item_data color3" style="line-height:22px">{{ field.content }}</span>
          </el-col>
        </template>
        <el-col :span="24" class="detail-item" v-if="Detail.certificates && Detail.certificates.length"
        >
          <span class="item-name">附件：</span>
          <span style="display: flex; flex-wrap: wrap">
            <div v-for="(file, index) in Detail.certificates" :key="index" class="file-item">
              <div class="file-item-container">
                <img :src="fileIcon[file.fileName.split('.').pop().toLowerCase()]" alt="" class="file-icon"/>
                <div class="file-info">
                  <div class="file-name">
                    <div class="fore">
                      {{ file.fileName.slice(0, file.fileName.lastIndexOf(".")) }}
                    </div>
                    <div class="back">.{{ file.fileName.split(".").pop() }}</div>
                  </div>
                  <div class="file-other">
                    <span class="file-size">{{ formatFileSize(file.fileSize) }}</span>
                    <span class="file-download" @click="$previewFile(file.picture)" >预览</span>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import { apiPopularityTeam } from "@/api/apiPopularityTeam"
import "@/utils/previewFile"
export default {
  data() {
    return {
      showpNumber: false,
      isCanLookPhone: false,
      Hometown: [],
      imgDlgVisible: false,
      imgUrl: "",
      showTooltip:false,
      fileIcon: {
        jpg: require("@/assets/fileIcon/image.png"),
        jpeg: require("@/assets/fileIcon/image.png"),
        png: require("@/assets/fileIcon/image.png"),
        pdf: require("@/assets/fileIcon/pdf.png"),
        zip: require("@/assets/fileIcon/zip.png"),
        rar: require("@/assets/fileIcon/zip.png"),
        doc: require("@/assets/fileIcon/word.png"),
        docx: require("@/assets/fileIcon/word.png"),
        xlsx: require("@/assets/fileIcon/xls.png"),
        xls: require("@/assets/fileIcon/xls.png")
      }
    }
  },
  props: {
    Detail: {
      type: Object
    }
  },
  components: {},
  computed: {
    categoryNameArr() {
      return this.Detail.categoryName ? this.Detail.categoryName.split(",") : []
    },
    hasAffCom() {
      if (this.Detail.companyNo) {
        // 公司发布
        return (
          this.Detail.affiliatedUnitPic &&
          !this.Detail.affiliatedUnitPic.startsWith("http")
        )
      } else {
        // 个人发布
        return (
          this.Detail.affiliatedStatus == 2 &&
          !this.Detail.affiliatedUnitPic.startsWith("http")
        )
      }
    }
  },
  methods: {
    // 隐藏联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },
    //  查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    //内容超出时,hover显示所有文本信息
    handleShowTooltip(event){
      let cell = event.target.querySelector('.el-tooltip');
      this.showTooltip = cell.scrollWidth === cell.offsetWidth;
    },
    /** @name 登录方法 */
    loginIndex() {
      let data = {
        callBack: function () {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    /**
     *@name 点击'查看联系方式'按钮
     */
    queryContactType() {
      let token = this.$store.state.token
      if (!token) {
        this.loginIndex()
      } else {
        this.isCanLookPhone = true
      }
    },
    /**
     * 班组工队下 跳转隶属单位企业网站
     * @param companyData 隶属单位信息
     */
    jumpComSite(companyData) {
      if (!this.hasAffCom) return
      const { companyNo, affiliatedUnitNo } = this.Detail
      const routeUrl = `${process.env.VUE_APP_MATERIALSURL}/company/?no=${
        affiliatedUnitNo || companyNo
      }&type=1&subMenuId=7`
      window.open(routeUrl, "_blank")
    },
    /**
     * 格式化页面显示的文件大小
     * @param fileSize 文件大小
     */
    formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize /1024 > 10) {
        return `${(fileSize /1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    },
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.information {
  padding: 10px 20px 20px 20px;
  .itemRow {
    font-size: 14px;
    color: #666666;
    .item_text {
      display: flex;
      .item_tag {
        margin-left: 5px;
        margin-bottom: 5px;
      }
      .item_tag:first-child {
        margin-left: 0;
      }
      /deep/ .el-tag.is-hit {
        background: none;
        border-color: #0286df;
        color: #0286df;
      }
      .item_data {
        // width: calc(100% - 80px);
        // margin-left: 5px;
        word-wrap: break-word;
      }
    }
    .item_img {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-top: 18px;
    }
    .single_hide {
      // 单行隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .color6 {
      color: #666666;
      font-size: 14px;
      font-weight: 400;
    }
    .color3 {
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      word-break: break-all;
      word-wrap: break-word;
    }
  }
  .item_text {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    margin-top: 20px;
    .project-text{
      width: 295px;
    }
  }
  .cooperative {
    margin-bottom:20px;
    // &:first-child{
    //   margin-top: 10px;
    // }
    &:last-child{
      margin-bottom: 0;
    }
    .cooperative_title {
      font-size: 18px;
      font-weight: 400;
      color: #b79255;
      border-bottom: 1px dashed #e4e7ed;
      padding-bottom: 10px;
      .cooperative_name{
        color: #B79255;
        font-size: 16px;
        height: 15px;
        padding-left: 10px;
        border-left: 3px solid #B79255;
        line-height: 15px;
      }
    }
    .detail-item {
      display: flex;
      padding-top: 10px;
      // &:first-child{
      //   padding-bottom: 0;
      // }
      // &:last-child{
      //   padding-bottom: 0;
      // }
      .item-name {
        font-size: 14px;
        flex-shrink: 0;
        font-size: 14px;
        color: var(--FC6);
      }
      .item-value {
        color: #333;
        font-size: 14px;
      }
      .file-item {
        .file-item-container {
          box-sizing: border-box;
          width: 236px;
          display: flex;
          margin: 0px 10px 10px 0px;
          padding: 10px;
          background-color: #fafafa;
          font-size: 14px;
          border-radius: 4px;
          .file-icon {
            width: 33px;
            height: 40px;
          }
          .file-info {
            flex: 1;
            padding-left: 10px;
            line-height: 1.2;
            .file-name {
              margin-bottom: 10px;
              display: flex;
              color: var(--FC3);
              .fore {
                max-width: 140px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
              }
              .back {
                flex-shrink: 0;
              }
            }
            .file-other {
              display: flex;
              justify-content: space-between;
              .file-size {
                color: var(--FC9);
              }
              .file-download {
                cursor: pointer;
                color: #0286df;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.popperCustoms {
  padding: 5px 10px!important;
  &.is-light {
    background: #ffffff !important;
    border: 1px solid #666666;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0;
    opacity: 1 !important;
    color: #666666 !important;
  }
}
</style>

